import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";

import { PrivateAppLazy } from "@/PrivateAppLazy";
import { PublicAppLazy } from "@/PublicAppLazy";
import { useClaims } from "@/features/auth/hooks/useClaims";
import { ServiceWorkerUpdateProvider } from "@/features/pwa/components/ServiceWorkerUpdateProvider";
import { Center, Loader } from "@meditect/medibase-components";

import { DynamicModuleErrorBoundary } from "./components/DynamicModuleErrorBoundary/DynamicModuleErrorBoundary";
import { ConnectivityContextProvider } from "./features/connectivity/components/ConnectivityProvider";

const App = (): React.ReactElement => {
  const [claims, isLoading] = useClaims();
  const isAuthenticated = !!claims;

  return (
    <DynamicModuleErrorBoundary>
      <ConnectivityContextProvider>
        <ServiceWorkerUpdateProvider>
          {isLoading ? (
            <Center h="full">
              <Loader />
            </Center>
          ) : (
            <BrowserRouter>
              <Suspense
                fallback={
                  <Center h="full">
                    <Loader />
                  </Center>
                }
              >
                {isAuthenticated && (claims.pharmacyId == null || claims.pin) ? <PrivateAppLazy /> : <PublicAppLazy />}
              </Suspense>
            </BrowserRouter>
          )}
        </ServiceWorkerUpdateProvider>
      </ConnectivityContextProvider>
    </DynamicModuleErrorBoundary>
  );
};

export default App;
